import { DefaultService } from '@/services/DefaultService';

export default class CentroCustoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(situacao, column, order = 'asc', limit = 50, page = 0, ...params) {
        return this._http.get(`${this._env}/financeiro/centro-custo.json?situacao=${situacao}&page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    find(id) {
        return this._http.get(`${this._env}/financeiro/centro-custo/${id}.json`, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    updateSituacao(obj) {
        return this._http.post(`${this._env}/financeiro/centro-custo/updatesituacao`, obj, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    save(obj) {
        return this._http.post(`${this._env}/financeiro/centro-custo`, obj, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/financeiro/getcombo/centro-custo.json?situacao=${situacao}&param=${params}`), this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }

}